import {
  TickerApiMatchState,
  CachedTickerMatchSeriesByUuid,
  TickerApiMatchStats,
  SimpleTickerApiMatchState
} from '../../../shared/indoor/ticker';
import { MatchConfiguration } from '../../../../shared/interfaces/models';
import { EventTeamSquads, EventArbitration } from '../../../../shared/event-api/model';
import { TickerApiTeam, TickerApiRanking } from '../../../shared/indoor/api';
import { CachedTickerMatchSeries } from '../../../shared/indoor/cache';
import { TickerApiMatchSet } from '../../../shared/common/ticker';

// has to match the TickerType in shared/common/ticker
export enum TickerType {
  INDOOR = "indoor",
  BEACH = "beach"
}

export interface TickerMatchDate {
  day: string
  time: string
}

export interface EventMatchState {
  matchConfig: MatchConfiguration
  teamSquads: EventTeamSquads
  arbitration: EventArbitration
}

export enum Status {
  PRE = "PRE",
  LIVE = "LIVE",
  POST = "POST"
}

export enum TickerMode {
  SIMPLE = "SIMPLE",
  DETAILED = "DETAILED"
}

/**
 * A matchstate combined from the TickerMatchState that gets sent with each event and
 * the EventMatchState which is build on the client as events arrive.
 */

export type DetailedTickerMatchState = (TickerApiMatchState & EventMatchState)
export type SimpleTickerMatchState = SimpleTickerApiMatchState
export type TickerMatchState = DetailedTickerMatchState | SimpleTickerMatchState

export type TickerMatchStats = TickerApiMatchStats

export interface TickerMatch {
  id: string
  teamDescription1: string
  team1: TickerTeam
  teamDescription2: string
  team2: TickerTeam
  date: number
  matchSeries: string
  indefinitelyRescheduled: boolean
  delayPossible: boolean
  formattedDate: string
  formattedTime: string
}

export type TickerTeam = TickerApiTeam
export type TickerMatchSet = TickerApiMatchSet
export type TickerRanking = TickerApiRanking

export type TickerMatchSeries = CachedTickerMatchSeries

export interface TickerMatchDay {
  matches: TickerMatch[]
  date: string
  formattedDate: string
}

export type TickerMatchDays = TickerMatchDay[]
export type TickerMatchSeriesByUuid = CachedTickerMatchSeriesByUuid
